var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4845 24.5H0.405125V8.14275H5.4845V24.5ZM2.94175 5.9115C1.31775 5.9115 0 4.56575 0 2.94175C0 2.16155 0.309934 1.4133 0.861619 0.861619C1.4133 0.309934 2.16155 0 2.94175 0C3.72195 0 4.4702 0.309934 5.02188 0.861619C5.57357 1.4133 5.8835 2.16155 5.8835 2.94175C5.8835 4.56575 4.56575 5.9115 2.94175 5.9115ZM24.4948 24.5H19.4268V16.5375C19.4268 14.6396 19.3883 12.2063 16.786 12.2063C14.1453 12.2063 13.7401 14.2677 13.7401 16.401V24.5H8.666V8.14275H13.5371V10.374H13.608C14.2861 9.08862 15.9425 7.73238 18.4135 7.73238C23.5541 7.73238 24.4991 11.1178 24.4991 15.5146V24.5H24.4948Z",
    fill: "#005BBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.df87a3fdc18a8d5bc2e0e3482a6cfd8c.svg";
export { ForwardRef as ReactComponent };